import { forwardRef } from 'react'
import { cn } from '@/lib/utils/cn'

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { label, className, disabled, ...rest },
  ref,
) {
  return (
    <label
      className={cn(
        'inline-flex cursor-pointer select-none items-center gap-2 text-md',
        disabled && 'cursor-not-allowed text-text-disabled',
        className,
      )}
    >
      <span className="relative inline-flex h-4 w-4 items-center justify-center">
        <input
          ref={ref}
          type="radio"
          disabled={disabled}
          className="peer absolute h-full w-full cursor-inherit opacity-0"
          {...rest}
        />
        <span
          aria-hidden="true"
          className={cn(
            'pointer-events-none absolute inset-0 rounded-full border bg-surface border-border-default transition-[border-color,border-width] duration-fast',
            'peer-hover:border-border-strong',
            'peer-checked:border-accent peer-checked:border-[1.5px]',
            'peer-focus-visible:shadow-focus',
            'peer-disabled:bg-muted peer-disabled:border-border-subtle',
          )}
        />
        <span
          aria-hidden="true"
          className={cn(
            'pointer-events-none relative h-2 w-2 rounded-full bg-accent opacity-0 transition-opacity duration-fast',
            'peer-checked:opacity-100',
          )}
        />
      </span>
      {label ? <span className="text-primary">{label}</span> : null}
    </label>
  )
})
